function csvCell(value) {
  const s = String(value ?? "");
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** Download rows as a UTF-8 CSV (with BOM, like the old getcsv-admin*.php exports). */
export function downloadCsv(headers, rows, filename) {
  const content = [headers, ...rows].map((r) => r.map(csvCell).join(",")).join("\r\n");
  const blob = new Blob(["﻿" + content], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/** RFC-4180-ish parser: quoted fields may contain commas, quotes ("") and newlines. */
export function parseCsvRecords(text) {
  const records = [];
  let row = [];
  let cell = "";
  let inQuotes = false;
  const src = String(text ?? "").replace(/^﻿/, "");

  for (let i = 0; i < src.length; i++) {
    const ch = src[i];
    if (inQuotes) {
      if (ch === '"' && src[i + 1] === '"') {
        cell += '"';
        i++;
      } else if (ch === '"') {
        inQuotes = false;
      } else {
        cell += ch;
      }
    } else if (ch === '"') {
      inQuotes = true;
    } else if (ch === ",") {
      row.push(cell);
      cell = "";
    } else if (ch === "\n" || ch === "\r") {
      if (ch === "\r" && src[i + 1] === "\n") i++;
      row.push(cell);
      records.push(row);
      row = [];
      cell = "";
    } else {
      cell += ch;
    }
  }
  if (cell !== "" || row.length) {
    row.push(cell);
    records.push(row);
  }
  return records.filter((r) => r.some((c) => String(c).trim() !== ""));
}

/**
 * Split parsed records into a header -> column index map and the data rows.
 * Throws "Not matched. You must add: ..." like old/admin/insertCSV*.php when a column is missing.
 */
export function locateCsvColumns(records, columns) {
  if (!records.length) throw new Error("The CSV file is empty.");
  const headers = records[0].map((h) => String(h).trim().toLowerCase());
  const index = {};
  const missing = [];
  columns.forEach((col) => {
    const i = headers.indexOf(col);
    if (i < 0) missing.push(col);
    index[col] = i;
  });
  if (missing.length) throw new Error(`Not matched. You must add: ${missing.join(", ")}`);
  const rows = records.slice(1);
  if (!rows.length) throw new Error("The CSV file has no data rows.");
  return { index, rows };
}
